import Axios from "axios";

export default function getAllCompanies(id="all",setAllCompanies) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/get-all-companies/${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        setAllCompanies(response.data.data);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
